export default __webpack_public_path__ + "static/media/totals_bg.da3e8528.svg";